import { connect } from 'react-redux'
import { createSelector } from 'reselect'

// Components
import { IconLink, Link } from '@tracklib/kit'
import { ShareButton } from 'components/base/share'
import InvitesList from 'components/base/inviteslist'

// Selectors
import { invitesEntities, ownProfileEntity } from 'selectors'

// Types
import { Invite } from 'types'

// Utils
import { useTracking } from 'modules/tracking/hooks'

import styles from './shareinvitefriendsblock.css'

const NEW_INVITATIONS_START_DATE = new Date('2018-11-01')

type ShareInviteFriendsBlockProps = {
  value: {
    title: string
    show_status_text: string
    hide_status_text: string
  }
  invites: Array<Invite>
  inviteKey: string
}

const ShareInviteFriendsBlock = ({ value: { title }, invites, inviteKey }: ShareInviteFriendsBlockProps): JSX.Element => {
  const trackEvent = useTracking()
  const path = `/subscribe/${inviteKey}/`
  const creditsEarned = invites.reduce((agg, invite) => (invite.status === 'BONUS_ACTIVATED' ? agg + 1 : agg), 0)
  const trackInvite = (source: string) =>
    trackEvent('Invite', {
      eventCategory: 'Invites',
      eventAction: 'send',
      eventLabel: source,
    })

  return (
    <div className={styles.pad}>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.buttons}>
          <ShareButton service="facebook" path={path} buttonClassName={styles.buttonFacebook} callback={() => trackInvite('facebook')} />
          <Link to="invite" modal className={styles.buttonLink} onClick={() => trackInvite('url')}>
            <IconLink /> Copy link
          </Link>
          <ShareButton
            service="twitter"
            path={path}
            buttonClassName={styles.button}
            callback={() => trackInvite('twitter')}
            text="Signup here for 15 free download credits and 30 days on Tracklib - the world’s first record store for sampling"
          />
        </div>
        <p className={styles.supportLink}>
          Visit our{' '}
          <a href="https://support.tracklib.com/hc/en-us/articles/360018872452" target="_blank" rel="noopener noreferrer">
            Support Center
          </a>{' '}
          if you have any questions
        </p>
      </div>
      {invites && invites.length > 0 && (
        <div>
          <p className={styles.totalInvites}>
            <strong>{`You have invited ${invites.length} friend${invites.length > 1 ? 's' : ''} and earned ${creditsEarned * 10} credit${
              creditsEarned > 1 || creditsEarned === 0 ? 's' : ''
            }.`}</strong>
          </p>
          <InvitesList invites={invites} />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = createSelector([invitesEntities, ownProfileEntity], (invites, profile) => {
  const invitesList = Object.keys(invites).map(id => invites[id])
  return {
    invites: invitesList.filter(inv => new Date(inv.created) > NEW_INVITATIONS_START_DATE),
    inviteKey: profile.invite_key,
  }
})

export { ShareInviteFriendsBlock as Component }
export default connect(mapStateToProps)(ShareInviteFriendsBlock)
